<div class="modal-header">
  <h4 class="modal-title">{{'changeProjectOptionPopup.title' | translate}}</h4>
</div>
<div class="modal-body pt-0">
  <div class="modal-body-inner">
    <p class="mb-3" [innerHTML]="'changeProjectOptionPopup.message' | translate"></p>
    <form [formGroup]="form">
      <tabset class="modal-tabs settings-tab">
        <tab>
          <ng-template tabHeading><strong>{{'changeProjectOptionPopup.label.fsf' | translate}}</strong></ng-template>
          <div *ngIf="includeProjectFormData">
            <div class="mb-3 row">
              <label class="col-md-4 col-form-label"><span class="icon-container"></span>{{'finalizeProject.label.articleNumberLong' | translate}}:</label>
              <label class="col-md-8 col-form-label">{{articleNumberLongString}}</label>
            </div>
          </div>
          <div class="mb-3 row" *ngIf="hasFinalizeProjectPermission && !!currentProject?.originProjectArticleNumberLong?.reducedArticleNumberLong">
            <label class="col-md-4 col-form-label"><span class="icon-container"></span>{{'changeProjectOptionPopup.label.originProjectarticleNumberLong' | translate}}:</label>
            <label class="col-md-8 col-form-label">{{currentProject?.originProjectArticleNumberLong.reducedArticleNumberLong}}</label>
          </div>
          <div class="mb-3 row">
            <label class="col-md-4 col-form-label" for="configuration-name"><span class="icon-container"></span>{{ 'changeProjectOptionPopup.label.project_name' | translate }}: </label>
            <div class="col-md-8">
              <input
                type="text"
                appInputAutoFocus
                spellcheck="false"
                id="configuration-name"
                name="text-input"
                class="form-control"
                [class.is-invalid]="checkControlValidity('projectName')"
                formControlName="projectName"
                [readonly]="!projectNameEditable">
              <div class="invalid-feedback">{{form.controls['projectName'].errors?.messageKey | translate: {'0': form.controls['projectName'].errors?.param} }}</div>
            </div>
          </div>
          <conf-settings-tab-content
            [form]="form"
            [showRequiredFields]="showRequiredFields"
            [options]="projectOptionContainer.fsfOptions"
            [editable]="projectOptionsEditable"
            [allowEditOfOptionLabels]="allowEditOfOptionLabels"
            (onNameEdit)="onEditOptionName($event)">
          </conf-settings-tab-content>
        </tab>
        <tab>
          <ng-template tabHeading><strong>{{'changeProjectOptionPopup.label.general' | translate}}</strong></ng-template>
          <conf-settings-tab-content
            [form]="form"
            [showRequiredFields]="showRequiredFields"
            [options]="projectOptionContainer.generalOptions"
            [editable]="projectOptionsEditable"
            [allowEditOfOptionLabels]="allowEditOfOptionLabels"
            (onNameEdit)="onEditOptionName($event)">
          </conf-settings-tab-content>
        </tab>
        <tab *ngIf="includeInternalOptions">
          <ng-template tabHeading><strong>{{'changeProjectOptionPopup.label.internal' | translate}}</strong></ng-template>
          <conf-settings-tab-content
            [form]="form"
            [showRequiredFields]="showRequiredFields"
            [options]="projectOptionContainer.internalOptions"
            [editable]="projectOptionsEditable"
            [allowEditOfOptionLabels]="false"
            (onNameEdit)="onEditOptionName($event)">
          </conf-settings-tab-content>
        </tab>
      </tabset>
    </form>
    <div class="edit-links small pt-3 ps-3">
      <a class="link" (click)="editArticleNumberMappingPopup()">
        <app-svg-icon type="edit-pen" [inline]="true"/>  {{'ChoiceActionSetting.label.user_option' | translate}}
      </a>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button id="button-cancel"
          type="button"
          class="btn btn-secondary btn-cancel"
          (click)="onCancel()">{{ (projectNameEditable || projectOptionsEditable) ? ('global.label.cancel' | translate) : ('global.label.close' | translate) }}
  </button>
  <button id="button-save"
          type="button"
          class="btn btn-primary btn-forward"
          (click)="onConfirm()"
          *ngIf="projectNameEditable || projectOptionsEditable">{{ (!confirmButtonLabel ? 'global.label.save' : confirmButtonLabel) | translate }}
  </button>
</div>
